import GetStartedCTA from './GetStartedCTA';
export default GetStartedCTA;